import React from "react";
import Moment from "moment";
/*
    For Redux, importing connect and action
    Redux connect is to access Redux states
    Redux actions to update the Redux states
*/
import { connect } from "react-redux";
import { updateForm, setStep, setInfo, setLatest, setCurrent } from "../../../store/actions/FormAction";
/*
    Importing React Scroll for animating scrolling down to elements
*/
import { animateScroll as scroll } from 'react-scroll';
/*
    Importing AlertDialogSlide for sliding Modal Window
*/
import AlertDialogSlide from "../../partials/AlertDialogSlide";
/*
    Importing NextStepButton that is a component that updates the page in Redux
*/
import NextInfoButton from "../../partials/NextInfoButton";
/*
    This page is using a template AccountLayout
*/
import AccountLayout from '../../../containers/AccountLayout';
/*
    Using Validation functions from utils folder
*/
import Validation from '../../../utils/Validation';
const validation = new Validation();

const today = new Date();
/*
    PhoneVerification view that displays the Phone Verification page
    Remember JSX requires you to use camelcasing of attributes
    (ie className vs 'class', htmlFor vs 'for', tabIndex vs tab-index)
    Remember JSX requires all tags be closed (ie: self closed <hr />, <br />)
    Create React App requires alt tags for all <img> elements (good for SEO too)
*/
class PersonalInfo extends React.Component {

  constructor(){
    super();

    this.namechecked = false;
    this.bdaychecked = false;
    this.ssnchecked = false;
    this.phonechecked = false;
    this.phoneallchecked = false;

    this.handleFirstNameBlur = this.handleFirstNameBlur.bind(this);
    this.handleLastNameBlur = this.handleLastNameBlur.bind(this);
    this.handleBdayBlur = this.handleBdayBlur.bind(this);
    this.handleSSNBlur = this.handleSSNBlur.bind(this);
    this.handlePhoneBlur = this.handlePhoneBlur.bind(this);

    this.handleFirstNameChange = this.handleFirstNameChange.bind(this);
    this.handleLastNameChange = this.handleLastNameChange.bind(this);
    this.handleBdayKeyUp = this.handleBdayKeyUp.bind(this);
    this.handleBdayChange = this.handleBdayChange.bind(this);
    this.handleSSNChange = this.handleSSNChange.bind(this);

    this.handlePhoneChange = this.handlePhoneChange.bind(this);
    this.handleMobileChange = this.handleMobileChange.bind(this);
    this.handleOfferChange = this.handleOfferChange.bind(this);

    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleShowAppCode = this.handleShowAppCode.bind(this);
    this.handleAppCodeChange = this.handleAppCodeChange.bind(this);
  }

  componentDidMount() {
    this.props.updateForm("pagename", "Personal Information");

    this.props.lateststep < 2 && this.props.setLatest(2);
    this.props.setCurrent(2);
    this.props.setStep(1);
    this.props.setInfo(0);

    //TODO: add proper authentication
    if (!this.props.loggedin && this.props.allchecked)
      this.props.updateForm("loggedin", true);

    //TODO: make input fields into components that know their own state (active or not)
    if (this.props.fn.length < 1){
      setTimeout(()=>{document.getElementById('fn').focus()},10);
    } else{
      document.getElementById("fn").classList.add('filled');
      document.querySelector("label[for='fn']").classList.add('activeaddy');
    }

    if (this.props.ln.length > 0){
      document.getElementById("ln").classList.add('filled');
      document.querySelector("label[for='ln']").classList.add('activeaddy');
    }
    if (this.props.fn.length > 0 && this.props.ln.length > 0){
      this.namechecked = true;
    }

    if (this.props.bday.length > 0){
      this.bdaychecked = true;
      document.getElementById("bday").classList.add('filled');
      document.querySelector("label[for='bday']").classList.add('active');
    }
    if (this.props.ssn.length > 0){
      this.ssnchecked = true;
      document.getElementById("ssn").classList.add('filled');
      document.querySelector("label[for='ssn']").classList.add('active');
    }
    if (this.props.phn.length > 0){
      this.phonechecked = true;
      document.getElementById("phn").classList.add('filled');
      document.querySelector("label[for='phn']").classList.add('active');

      if (this.props.ismobilechecked){
        this.phoneallchecked = true;
        document.getElementById("mobilenumbercheck").classList.remove('hidden');
        document.getElementById("receiveofferscheck").classList.remove('hidden');
        document.getElementById("appcodecheck").classList.remove('hidden');

        this.props.ismobile ? document.getElementById("ismobile").classList.add('activated') : document.getElementById("notmobile").classList.add('activated');

        if (this.props.allpersonal){

          this.props.receiveoffers ? document.getElementById("yesoffers").classList.add('activated') : document.getElementById("nooffers").classList.add('activated');

          if (this.props.hasappcode){
            document.getElementById("hasappcode").classList.remove('hidden');
            if (this.props.appcode.length > 0){
              if (this.props.appcode.length > 5){
                document.querySelector("label[for='appcode']").classList.add('active');
              }
            }
          }
        }
      }

    }

    //alert("new code added")
    const AUTOFILLED = 'is-autofilled';
    const onAutoFillStart = (el) => el.classList.add(AUTOFILLED);
    const onAutoFillCancel = (el) => el.classList.remove(AUTOFILLED);
    const onAnimationStart = ({ target, animationName }) => {
        switch (animationName) {
            case 'onAutoFillStart':
                //console.log("onAutoFillCancel");
                return onAutoFillStart(target);
            case 'onAutoFillCancel':
                //console.log("onAutoFillCancel");
                return onAutoFillCancel(target);
            default:
                break;
        }
    }
    document.querySelector('input').addEventListener('animationstart', onAnimationStart, false);
  }

  handleFirstNameChange(e) {
    let fn = e.target.value;
    this.props.updateForm("fn", fn);

    let fntip = document.getElementById("fntip");
    const fnlabel = document.querySelector("label[for='fn']");

    if (fn.length > 1){
      fntip.classList.add("hidden");
      fntip.innerHTML = "";
      fnlabel.classList.add("activeaddy");
      this.namechecked = true;
    } else {
      fnlabel.classList.remove("activeaddy");
      this.namechecked = false;
    }
  }
  handleFirstNameBlur(e) {
    let fn = e.target.value;
    let fntip = document.getElementById("fntip");

    this.namechecked = false;
    if (fn.length > 0){
      if (fn.length < 2){
        fntip.classList.remove("hidden");
        fntip.innerHTML = "Please enter your first name";
      } else {
        if (this.props.ln.length > 1)
          this.namechecked = true;
      }
    } else {
      e.target.classList.remove('filled');
      fntip.classList.remove("hidden");
      fntip.innerHTML = "Please enter your first name.";
    }

    if (validation.checkAll([true,this.namechecked,this.bdaychecked,this.ssnchecked,this.phonechecked,this.phoneallchecked])){
      this.props.updateForm("allpersonal", true);
    } else {
      this.props.updateForm("allpersonal", false);
    }

  }
  handleFirstNameFocus(e) {
    e.target.classList.add('filled');
  }

  handleLastNameChange(e) {
    let ln = e.target.value;
    this.props.updateForm("ln", ln);

    let lntip = document.getElementById("lntip");
    const lnlabel = document.querySelector("label[for='ln']");

    if (ln.length > 1){
      lntip.classList.add("hidden");
      lntip.innerHTML = "";
      lnlabel.classList.add("activeaddy");
      this.namechecked = true;
    } else {
      lnlabel.classList.remove("activeaddy");
      this.namechecked = false;
    }
  }
  handleLastNameBlur(e) {
    let ln = e.target.value;
    let lntip = document.getElementById("lntip");

    this.namechecked = false;
    if (ln.length > 0){
      if (ln.length < 2){
        lntip.classList.remove("hidden");
        lntip.innerHTML = "Please enter your last name";
      } else {
        if (this.props.fn.length > 1)
          this.namechecked = true;
        if (window.pageYOffset < 250)
          scroll.scrollTo(250, {duration: 1000});
      }
    } else {
      e.target.classList.remove('filled');
      lntip.classList.remove("hidden");
      lntip.innerHTML = "Please enter your last name.";
    }

    if (validation.checkAll([true,this.namechecked,this.bdaychecked,this.ssnchecked,this.phonechecked,this.phoneallchecked])){
      this.props.updateForm("allpersonal", true);
    } else {
      this.props.updateForm("allpersonal", false);
    }
  }
  handleLastNameFocus(e) {
    e.target.classList.add('filled');
  }

  handleBdayKeyUp(e) {
    //check if they hit enter or right arrow key
    // eslint-disable-next-line
    if(e.keyCode == 13 || e.keyCode == 45 || e.keyCode == 191){
      let bday = this.props.bday;
      bday = bday.replace(/\D/g, '');
      let split = 2;
  		let chunk = [];
  		for (let i = 0; i < bday.length; i += split) {
  			split = (i <= 3) ? 2 : 4;
  			chunk.push( bday.substr( i, split ) );
  		}
      if (chunk[0]) chunk[0] = validation.checkDate(chunk[0], 12);//month
      if (chunk[1]) chunk[1] = validation.checkDate(chunk[1], 31);//day
      if (chunk[2]) chunk[2] = validation.checkYear(chunk[2], 1898, today.getFullYear()-1);//year
      //check if they just want to input a single digit, if so add the zero for them
      // eslint-disable-next-line
      if (bday.length < 2 && chunk[0] == '1'){
        chunk[0] = '0'+ chunk[0];
      // eslint-disable-next-line
      } else if (bday.length > 2 && chunk[1].length === 1 && chunk[1] == '1' || chunk[1] == '2' || chunk[1] == '3'){
        chunk[1] = '0'+ chunk[1];
      }
      let tmpbday = chunk.join("/");

      this.props.updateForm("bday", tmpbday);
    }
  }

  handleBdayChange(e) {
    let tempbday = e.target.value;
    let bday = tempbday.replace(/\D/g, '');
    let bdaytip = document.getElementById("bdaytip");

    if (bday.length === 0){
      bdaytip.classList.remove("hidden");
      bdaytip.innerHTML = "Please enter numbers only";
    } else {
      bdaytip.classList.add("hidden");
      bdaytip.innerHTML = "";
    }

    let split = 2;
		let chunk = [];
		for (let i = 0; i < bday.length; i += split) {
			split = (i <= 3) ? 2 : 4;
			chunk.push( bday.substr( i, split ) );
		}

    if (chunk[0]) {
      let tempmth = chunk[0];

      // eslint-disable-next-line
      if (tempmth.length > 1 && tempmth[0] == '1' && parseInt(tempmth[1], 10) > 2){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter a month no more than 12.";
      }
      chunk[0] = validation.checkDate(chunk[0], 12);//month
    }
    if (chunk[1]) {
      bdaytip.classList.add("hidden");
      let tempday = chunk[1];

      // eslint-disable-next-line
      if (tempday.length > 1 && tempday[0] == '3' && parseInt(tempday[1], 10) > 1){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter a date no more than 31.";
      }
      chunk[1] = validation.checkDate(chunk[1], 31);//day
    }
    if (chunk[2]) {
      bdaytip.classList.add("hidden");
      let tempyr = chunk[2];
      chunk[2] = validation.checkYear(chunk[2], today.getFullYear()-120, today.getFullYear()-1);//year
      if (parseInt(tempyr[0], 10) > 2){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter the 4 digit year (ie: 1987).";
        chunk[2] = "";
      } else if (parseInt(tempyr[0], 10) < 1){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter the 4 digit year (ie: 2000).";
        chunk[2] = "";
      // eslint-disable-next-line
      } else if (tempyr.length > 1 && tempyr[0] == '1' && parseInt(tempyr[1], 10) < 8){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter the 4 digit year (ie: 2000).";
        chunk[2] = tempyr[0];
      // eslint-disable-next-line
      } else if (tempyr.length > 1 && tempyr[0] == '2' && parseInt(tempyr[1], 10) > 0){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter the 4 digit year (ie: 2000).";
        chunk[2] = tempyr[0];
      // eslint-disable-next-line
      } else if (tempyr.length > 2 && tempyr[0] == '2' && tempyr[1] == '0' && parseInt(tempyr[2], 10) > 2){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter the 4 digit year (ie: 1987).";
        chunk[2] = tempyr[0]+tempyr[1];
      } else if (tempyr.length > 3 && parseInt(tempyr, 10) > today.getFullYear()){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter a valid year (ie: 2000).";
        chunk[2] = tempyr[0]+tempyr[1]+tempyr[2];
      // eslint-disable-next-line
      } else if (tempyr.length > 1 && tempyr[0] == '1' && parseInt(tempyr[1], 10) < 9){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Over 120 years old? Call us.";
      } else if (tempyr.length > 3 && parseInt(tempyr, 10) > today.getFullYear()-1){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter a later year.";
      }
    }

    let tmpbday = chunk.join("/");

    this.props.updateForm("bday", tmpbday);

    const bdaylabel = document.querySelector("label[for='bday']");

    if (tmpbday.length > 9){
      bdaytip.classList.add("hidden");
      bdaytip.innerHTML = "";
      bdaylabel.classList.add("active");
      //check date to see if too young
      //need state to see if legal age 19 or 18
      let birthday = Moment(tmpbday, "MM/DD/YYYY");
      let age = birthday.diff(Moment(), 'years') * -1;
      this.props.updateForm("tooyoung", false);
      if (age < this.props.legalage ){
        this.props.updateForm("tooyoung", true);
      }
      this.bdaychecked = true;
    } else {
      bdaylabel.classList.remove("active");
      this.bdaychecked = false;
    }
  }
  handleBdayBlur(e) {
    let bday = e.target.value;
    let bdaytip = document.getElementById("bdaytip");

    this.bdaychecked = false;
    if (bday.length > 0){
      if (bday.length < 10){
        bdaytip.classList.remove("hidden");
        bdaytip.innerHTML = "Please enter your full birthday.";
      } else {
        if (window.pageYOffset < 300)
          scroll.scrollTo(300, {duration: 1000});
        this.bdaychecked = true;
      }
    } else {
      e.target.classList.remove('filled');
      bdaytip.classList.remove("hidden");
      bdaytip.innerHTML = "Please enter your birthday.";
    }

    if (validation.checkAll([true,this.namechecked,this.bdaychecked,this.ssnchecked,this.phonechecked,this.phoneallchecked])){
      this.props.updateForm("allpersonal", true);
    } else {
      this.props.updateForm("allpersonal", false);
    }
  }
  handleBdayFocus(e) {
    e.target.classList.add('filled');
  }

  handleSSNChange(e) {
    let ssn = e.target.value;
    let ssntip = document.getElementById("ssntip");

    ssn = ssn.replace(/\D/g, '');
    if (ssn.length === 0){
      ssntip.classList.remove("hidden");
      ssntip.innerHTML = "Please enter numbers only";
    } else {
      ssntip.classList.add("hidden");
      ssntip.innerHTML = "";
    }

		let split = 2;
		let chunk = [];
		for (let i = 0; i < ssn.length; i += split) {
			split = (i < 4) ? ( ( i >= 3 && i <= 4 ) ? 2 : 3 ) : 4;
			chunk.push( ssn.substr( i, split ) );
		}
    let tmpssn = chunk.join("-");

    const ssnlabel = document.querySelector("label[for='ssn']");

    if (tmpssn.length === 11 && validation.validateSSN(tmpssn)){
      ssntip.classList.add("hidden");
      ssntip.innerHTML = "";
      ssnlabel.classList.add("active");
      this.ssnchecked = true;
      let last4 = tmpssn.substr(tmpssn.length - 4);
      this.props.updateForm("last4ssn", last4);
    } else {
      ssnlabel.classList.remove("active");
      this.ssnchecked = false;
    }
    this.props.updateForm("ssn", tmpssn);
  }
  handleSSNBlur(e) {
    let ssn = e.target.value;
    let ssntip = document.getElementById("ssntip");

    this.ssnchecked = false;
    if (ssn.length > 0){
      if (ssn.length < 11){
        ssntip.classList.remove("hidden");
        ssntip.innerHTML = "Please enter 9 digits.";
      } else if (!validation.validateSSN(ssn)){
        ssntip.classList.remove("hidden");
        ssntip.innerHTML = "Please enter a valid Social Security Number";
      } else {
        this.ssnchecked = true;
        if (window.pageYOffset < 350)
          scroll.scrollTo(350, {duration: 1000});
      }
    } else {
      e.target.classList.remove('filled');
      ssntip.classList.remove("hidden");
      ssntip.innerHTML = "Please enter your Social Security Number.";
    }

    if (validation.checkAll([true,this.namechecked,this.bdaychecked,this.ssnchecked,this.phonechecked,this.phoneallchecked])){
      this.props.updateForm("allpersonal", true);
    } else {
      this.props.updateForm("allpersonal", false);
    }
  }
  handleSSNFocus(e) {
    e.target.classList.add('filled');
  }

  handlePhoneChange(e) {
    let phn = e.target.value;
    let phntip = document.getElementById("phntip");

    phn = phn.replace(/\D/g, '');
    if (phn.length === 0){
      phntip.classList.remove("hidden");
      phntip.innerHTML = "Please enter numbers only";
    } else {
      phntip.classList.add("hidden");
      phntip.innerHTML = "";
    }

    let split = 3;
    let chunk = [];
    for (let i = 0; i < phn.length; i += split) {
      split = (i <= 3) ? 3 : 4;
      chunk.push( phn.substr( i, split ) );
    }
    if (chunk[0]) chunk[0] = validation.checkPhoneNum(chunk[0], 200);
    let tmp = chunk.join("-");
    this.props.updateForm("phn", tmp);

    const phnlabel = document.querySelector("label[for='phn']");

    if (validation.validatePhone(phn)){
      phntip.classList.add("hidden");
      phntip.innerHTML = "";
      phnlabel.classList.add("active");
      document.getElementById("mobilenumbercheck").classList.remove("hidden");
      this.phonechecked = true;
    } else {
      phnlabel.classList.remove("active");
      this.phonechecked = false;
    }
  }
  handlePhoneBlur(e) {
    let phn = e.target.value;
    let phntip = document.getElementById("phntip");

    this.phonechecked = false;
    if (phn.length > 0){
      if (!validation.validatePhone(phn)){
        phntip.classList.remove("hidden");
        phntip.innerHTML = "Please enter a valid phone number.";
      } else {
        this.phonechecked = true;
        if (window.pageYOffset < 450)
          scroll.scrollTo(450, {duration: 1000});
      }
    } else {
      e.target.classList.remove('filled');
      phntip.classList.remove("hidden");
      phntip.innerHTML = "Please enter your phone number.";
    }

    if (validation.checkAll([true,this.namechecked,this.bdaychecked,this.ssnchecked,this.phonechecked,this.phoneallchecked])){
      this.props.updateForm("allpersonal", true);
    } else {
      this.props.updateForm("allpersonal", false);
    }
  }
  handlePhoneFocus(e) {
    e.target.classList.add('filled');
  }

  handleMobileChange(e) {
    e.preventDefault();

    this.props.updateForm("ismobilechecked", true);

    [].forEach.call( document.querySelectorAll('.ismobilebtn'), function(el) {
      el.classList.remove("activated");
    });
    e.target.classList.add("activated");

    const textmessages = document.getElementById("textmessages");
    if (e.target.dataset.answer === "Not Mobile"){
      this.props.updateForm("ismobile", false);
      textmessages.classList.add("hidden");
    } else {
      this.props.updateForm("ismobile", true);
      textmessages.classList.remove("hidden");
    }

    const receiveofferschk = document.getElementById("receiveofferscheck")
    receiveofferschk.classList.remove("hidden");
    if (window.pageYOffset < 500)
      scroll.scrollTo(500, {duration: 1000});
  }

  handleOfferChange(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.offerbtn'), function(el) {
      el.classList.remove("activated");
    });
    e.target.classList.add("activated");
    if (e.target.dataset.answer === "No Offers"){
      this.props.updateForm("receiveoffers", false);
    } else {
      this.props.updateForm("receiveoffers", true);
    }

    const appcodechk = document.getElementById("appcodecheck")
    appcodechk.classList.remove("hidden");
    if (window.pageYOffset < 650)
      scroll.scrollTo(650, {duration: 1000});

    this.phoneallchecked = true;
    if (validation.checkAll([true,this.namechecked,this.bdaychecked,this.ssnchecked,this.phonechecked])){
      this.props.updateForm("allpersonal", true);
    } else {
      this.props.updateForm("allpersonal", false);
    }
  }

  handleCodeChange(e) {
    e.preventDefault();

    [].forEach.call( document.querySelectorAll('.codebtn'), function(el) {
      el.classList.remove("activated");
    });
    e.target.classList.add("activated");

    const hasappcode = document.getElementById("hasappcode");
    if (e.target.dataset.answer === "No Code"){
      this.props.updateForm("allpersonal", true);
      this.props.updateForm("hasappcode", false);
      hasappcode.classList.add("hidden");
    } else {
      this.props.updateForm("hasappcode", true);
      hasappcode.classList.remove("hidden");
      if (window.pageYOffset < 800)
        scroll.scrollTo(800, {duration: 1000});
      document.querySelector("label[for='appcode']").focus();
      if (this.props.appcode.length > 5){
        this.props.updateForm("allpersonal", true);
      } else {
        this.props.updateForm("allpersonal", false);
      }
    }
  }
  handleShowAppCode(e) {
    e.preventDefault();

    const hasappcode = document.getElementById("hasappcode");
    if (this.props.hasappcode){
      this.props.updateForm("hasappcode", false);
      hasappcode.classList.add("hidden");
    } else {
      this.props.updateForm("hasappcode", true);
      hasappcode.classList.remove("hidden");
      if (window.pageYOffset < 800)
        scroll.scrollTo(800, {duration: 1000});
      document.querySelector("label[for='appcode']").focus();
    }
  }

  handleAppCodeChange(e) {
    let appcode = e.target.value;
    this.props.updateForm("appcode", appcode);

    const codelabel = document.querySelector("label[for='appcode']");
    //TODO check DB for match
    if (appcode.length > 5){
      let appcodetip = document.getElementById("appcodetip");
      appcodetip.classList.add("hidden");
      appcodetip.innerHTML = "";
      codelabel.classList.add("active");
    } else {
      codelabel.classList.remove("active");
    }
  }

  handleAppCodeBlur(e) {
    let appcode = e.target.value;

    let appcodetip = document.getElementById("appcodetip");

    //TODO check JAG API to check match?
    if (appcode.length <= 5){
      appcodetip.classList.remove("hidden");
      appcodetip.innerHTML = "Please enter a valid Application Code.";
    } else {
      if (window.pageYOffset < 900)
        scroll.scrollTo(900, {duration: 1000});
    }
  }

  render() {

    const nextInfo = 1;
    const nextLink = "/employmentinfo"; //changed from addressinfo because Google Maps API not working
    const btnText = "Continue";
    const btnClasses = "padtop30 btn next-step";

    return (
        <AccountLayout>
          <div className="container" id="stepper-step-3">
            <div className="text-center topcopy">
              <h1>Tell us about yourself</h1>
            </div>
            <hr />
            <form className="flowform">
                <input type="hidden" value="needed for disabling autocomplete" />
                <div className="form-group">
                  <label id="namelabel"> Your name</label>
                  <label htmlFor="fn" className="focused">
                    <div className="errortip hidden" id="fntip">
                        Please provide your first name.
                    </div>
                    <input type="text" name="fn" id="fn" autoComplete="fn" className="form-control" value={this.props.fn} onChange={this.handleFirstNameChange} onBlur={this.handleFirstNameBlur} onFocus={this.handleFirstNameFocus} tabIndex="1"/>
                    <span className="floating-label">First</span>
                  </label>
                  <label htmlFor="ln" className="ptop focused">
                    <div className="errortip hidden" id="lntip">
                        Please provide your last name.
                    </div>
                    <input type="text" name="ln" id="ln" autoComplete="ln" className="form-control" value={this.props.ln} onChange={this.handleLastNameChange} onBlur={this.handleLastNameBlur} onFocus={this.handleLastNameFocus} tabIndex="2" />
                    <span className="floating-label">Last</span>
                  </label>
                </div>
                <div className="form-group">
                    <label htmlFor="bday" className="focused">
                      Your birthday
                      <div className="errortip hidden" id="bdaytip">
                          Please provide your birthday starting with the month.
                      </div>
                      <input type="text" name="bday" id="bday" autoComplete="bday" value={this.props.bday} onKeyUp={this.handleBdayKeyUp} onChange={this.handleBdayChange} onBlur={this.handleBdayBlur} onFocus={this.handleBdayFocus} className="form-control" tabIndex="3" maxLength="10"/>
                      <span className="floating-label">mm/dd/yyyy (digits only)</span>
                    </label>
                </div>
                <div className="form-group">
                    <label htmlFor="ssn" className="focused">
                      Your Social Security Number (SSN)
                      <div className="errortip hidden" id="ssntip">
                          Please provide your Social Security Number.
                      </div>
                      <input type="text" name="ssn" id="ssn" autoComplete="ssn" value={this.props.ssn} onChange={this.handleSSNChange} onBlur={this.handleSSNBlur} onFocus={this.handleSSNFocus} className="form-control" tabIndex="4" maxLength="11"/>
                      <span className="floating-label">Enter 9 digit number</span>
                    </label>
                </div>

                <div className="form-group">
                    <label htmlFor="phn" className="focused">
                      Your phone number
                      <div className="errortip hidden" id="phntip">
                          Please provide a valid phone number.
                      </div>
                      <input type="tel" name="phn" id="phn" autoComplete="phn" value={this.props.phn} onChange={this.handlePhoneChange} onBlur={this.handlePhoneBlur} onFocus={this.handlePhoneFocus} className="form-control" tabIndex="5" maxLength="12"/>
                      <span className="floating-label">eg 512-123-4567</span>
                      <div className="nothuman"><input type="text" name="phone" /></div>
                    </label>
                </div>

                <div id="mobilenumbercheck" className="nopadbuttons text-center hidden">
                    <p className="buttontitle">Is this your mobile number?</p>
                    <div id="mobilenumberbuttons" className="button-group padtop15">
                      <a id="notmobile" className="btn yesno ismobilebtn" data-answer="Not Mobile" onClick={this.handleMobileChange} tabIndex="6">
                        No
                      </a>
                      <a id="ismobile" className="btn yesno ismobilebtn" data-answer="Is Mobile" onClick={this.handleMobileChange} tabIndex="7">
                        Yes
                      </a>
                    </div>
                </div>
                <div id="receiveofferscheck" className="nopadbuttons hidden text-center">
                    <p className="buttontitle">Would you like to receive special offers and promotions via <span id="textmessages" className="hidden">text messages and/or</span> phone calls?</p>
                    <p className="nobottom"><AlertDialogSlide linkText="Check out the terms." tip="smsterms" /></p>
                    <div className="button-group padtop15">
                      <a id="nooffers" className="btn yesno offerbtn" data-answer="No Offers" onClick={this.handleOfferChange} tabIndex="8">
                        No
                      </a>
                      <a id="yesoffers" className="btn yesno offerbtn" data-answer="Offers" onClick={this.handleOfferChange} tabIndex="9">
                        Yes
                      </a>
                    </div>
                </div>
                <div id="appcodecheck" className="padtop30 hidden text-center">
                    <a onClick={this.handleShowAppCode}>
                      <img className="style-svg offericon" src="/images/svg/mailoffer-svg.svg" alt="" style={{width:'40px',marginRight:'5px',display:'inline'}}/>
                      <p style={{display:'inline'}}>Received a mail offer?</p>
                    </a>

                    <div id="hasappcode" className="form-group hidden text-center padtop">
                      <p className="nobottom"><AlertDialogSlide linkText="What’s this?" tip="appcode" linkImage="images/svg/info.svg" /></p>
                      <div className="errortip hidden" id="appcodetip">
                          Please provide a valid Application Code.
                      </div>
                      <label htmlFor="appcode" style={{textAlign:'left'}}>
                        Your Application Code
                        <input type="text" name="appcode" id="appcode" placeholder="" value={this.props.appcode} onChange={this.handleAppCodeChange} onBlur={this.handleAppCodeBlur} className="form-control" tabIndex="12" maxLength="12"/>
                      </label>
                    </div>
                </div>

                <NextInfoButton next={nextLink} btnText={btnText} btnClasses={btnClasses} disableNext={!this.props.allpersonal} hideNext={!this.props.ismobilechecked} infostep={nextInfo} tabIndex="13"/>
              </form>
          </div>
        </AccountLayout>
        );
    }
}

const mapStateToProps = (state) => ({
    fn: state.FormReducer.fn,
    ln: state.FormReducer.ln,
    bday: state.FormReducer.bday,
    legalage: state.FormReducer.legalage,
    tooyoung: state.FormReducer.tooyoung,
    st: state.FormReducer.st,
    stt: state.FormReducer.stt,
    ssn: state.FormReducer.ssn,
    phn: state.FormReducer.phn,
    ismobile: state.FormReducer.ismobile,
    ismobilechecked: state.FormReducer.ismobilechecked,
    receiveoffers: state.FormReducer.receiveoffers,
    hasappcode: state.FormReducer.hasappcode,
    appcode: state.FormReducer.appcode,
    allpersonal: state.FormReducer.allpersonal,
    lateststep: state.FormReducer.lateststep,
    loggedin: state.FormReducer.loggedin,
    allchecked: state.FormReducer.allchecked
});

const mapDispatchToProps = (dispatch) => ({
    updateForm: (stateType, value) => dispatch(updateForm(stateType, value)),
    setStep: (step) => dispatch(setStep(step)),
    setInfo: (infostep) => dispatch(setInfo(infostep)),
    setLatest: (lateststep) => dispatch(setLatest(lateststep)),
    setCurrent: (currentstep) => dispatch(setCurrent(currentstep)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo)



// WEBPACK FOOTER //
// ./src/components/views/PersonalInfo/index.js